import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@src/components/Label';
import './styles.scss';

export default function DescriptionItems({ description, items }) {
  return (
    <div className="description-items">
      <div className="description-items__title">{description}</div>

      <div className="description-items__list">
        {items.map((item, i) => (
          <Label key={i} text={item} wrapperClassName="description-items__item" />
        ))}
      </div>
    </div>
  );
}

DescriptionItems.propTypes = {
  description: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};
